import { useRef, useState } from "react";

export default function useCarouselDrag({
  itemWidth,
  onSwipeLeft,
  onSwipeRight,
  onSnapBack,
}) {
  const startXRef = useRef(0);
  const deltaXRef = useRef(0);
  const isDragging = useRef(false);
  const preventClickRef = useRef(false);

  const [dragOffset, setDragOffset] = useState(0);

  const handleDragStart = (e) => {
    isDragging.current = true;
    startXRef.current = e.touches ? e.touches[0].clientX : e.clientX;
    deltaXRef.current = 0;
  };

  const handleDragMove = (e) => {
    if (!isDragging.current) return;
    const currentX = e.touches ? e.touches[0].clientX : e.clientX;
    deltaXRef.current = currentX - startXRef.current;
    setDragOffset(deltaXRef.current);

    if (Math.abs(deltaXRef.current) > 5) {
      preventClickRef.current = true;
    }
  };

  const handleDragEnd = () => {
    if (!isDragging.current) return;
    isDragging.current = false;

    const threshold = itemWidth / 4;
    if (Math.abs(deltaXRef.current) > threshold) {
      deltaXRef.current < 0 ? onSwipeLeft?.() : onSwipeRight?.();
    } else {
      onSnapBack?.();
    }

    setDragOffset(0);
    deltaXRef.current = 0;

    // Delay reset of preventClick to avoid race with onClick
    setTimeout(() => {
      preventClickRef.current = false;
    }, 0);
  };

  const getSafeClickHandler = (userClick) => (e) => {
    if (preventClickRef.current) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    userClick?.(e);
  };

  return {
    dragOffset,
    isDragging: isDragging.current,
    handleDragStart,
    handleDragMove,
    handleDragEnd,
    getSafeClickHandler,
  };
}
